export class RoofType {
  static FLAT = 1;
  static PITCHED = 2;
  static GABLE = 3;
  static COMPLICATED = 4;
}
